const defaultUser = {
  userName: '',
  firstName: '',
  roles: [],
  groups: [],
  termsAccepted: null,
  access: {
    views: [],
  },
  customerGroupIds: [],
  customerGroupNames: [],
}

const state = {
  user: defaultUser,
}

const getters = {
  checkAccess: state => view => {
    return state.user.access?.views?.includes(view) ?? false
  },
  // checkRole: state => role => {
  //   if (state.user.roles) {
  //     return state.user.roles.includes(role)
  //   }
  //   return false
  // },
}

const actions = {
  updateAccess({ commit }, obj) {
    commit('setAccess', obj)
  },
  updateUser({ commit }, obj) {
    commit('setUser', obj)
  },
  resetUser({ commit }, obj) {
    commit('resetUser', obj)
  },
}

const mutations = {
  setAccess(state, obj) {
    state.user = obj
  },
  resetUser(state, obj = defaultUser) {
    state.user = obj
  },
  setUser(state, obj) {
    state.user = {
      ...state.user,
      ...obj,
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
